import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, AppContextType } from '@contexts/AppContext';
import { TI502026Props } from '@interfaces/ti50';

import Layout from './Layout';

const queryClient = new QueryClient();

const TI502026 = ({
  env,
  initialCurrentUser,
  isWebview,
  ...restProps
}: Omit<AppContextType, 'isGdprRequired'> & TI502026Props): JSX.Element => (
  <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
    <QueryClientProvider client={queryClient}>
      <Layout {...restProps} />
    </QueryClientProvider>
  </AppContextProvider>
);

export default TI502026;
